module.exports = {"330283001":"锦屏街道","330283002":"岳林街道","330283003":"江口街道","330283004":"西坞街道","330283005":"萧王庙街道","330283100":"溪口镇","330283103":"尚田镇","330283104":"莼湖镇","330283106":"裘村镇","330283107":"大堰镇","330283108":"松岙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330283.json
// module id = 888
// module chunks = 0